<template>
  <div class="social-share-container" :style="containerStyle">
    <div v-if="showTitle && title" class="social-share-title" :style="titleStyle">
      {{ title }}
    </div>
    <div class="social-share-icons" :style="iconsWrapperStyle">
      <a
        v-for="platform in enabledPlatforms"
        :key="platform.key"
        :href="getShareUrl(platform.key)"
        target="_blank"
        rel="noopener noreferrer"
        class="social-share-icon"
        :class="`social-${platform.key}`"
      >
        <i :class="platform.icon" :style="getIconStyle(platform)"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { getSocialShareUrl, getEnabledPlatforms, getAllPlatforms } from '@src/helpers/social-sharing'

export default {
  name: 'SocialShare',
  
  props: {
    // URL to share
    shareUrl: {
      type: String,
      required: true
    },
    
    // Configuration object with enabled flags (e.g., { FacebookEnabled: true, TwitterEnabled: true })
    config: {
      type: Object,
      default: null
    },
    
    // Show all platforms if no config provided
    showAll: {
      type: Boolean,
      default: false
    },
    
    // Title text
    title: {
      type: String,
      default: ''
    },
    
    // Show title
    showTitle: {
      type: Boolean,
      default: false
    },
    
    // Title styling
    titleColor: {
      type: String,
      default: '#000000'
    },
    
    titleFontSize: {
      type: Number,
      default: 16
    },
    
    // Icon size
    iconSize: {
      type: Number,
      default: 50
    },
    
    // Layout alignment
    align: {
      type: String,
      default: 'center'
    }
  },
  
  computed: {
    enabledPlatforms() {
      if (this.showAll) {
        return getAllPlatforms()
      }
      
      if (!this.config) {
        return []
      }
      
      // Support legacy TwitterEnabled for backwards compatibility
      const normalizedConfig = { ...this.config }
      if (normalizedConfig.TwitterEnabled && !normalizedConfig.XEnabled) {
        normalizedConfig.XEnabled = normalizedConfig.TwitterEnabled
      }
      
      return getEnabledPlatforms(normalizedConfig)
    },
    
    containerStyle() {
      return {
        textAlign: this.align
      }
    },
    
    titleStyle() {
      return {
        color: this.titleColor,
        fontSize: `${this.titleFontSize}px`,
        marginBottom: '10px'
      }
    },
    
    iconsWrapperStyle() {
      return {
        display: 'flex',
        justifyContent: this.align === 'left' ? 'flex-start' : this.align === 'right' ? 'flex-end' : 'center',
        flexWrap: 'wrap',
        gap: '15px'
      }
    }
  },
  
  methods: {
    getShareUrl(platform) {
      return getSocialShareUrl(platform, this.shareUrl)
    },
    
    getIconStyle(platform) {
      return {
        fontSize: `${this.iconSize}px`,
        color: platform.color,
        transition: 'transform 0.2s'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.social-share-container {
  padding: 5px 0;
}

.social-share-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.social-share-icons {
  .social-share-icon {
    display: inline-block;
    text-decoration: none;
    transition: transform 0.2s;
    
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>

